'use strict';
import $ from 'jquery';
import throttle from 'lodash/throttle';
import { EventEmitter } from 'events';
import debounce from 'lodash/debounce';

const $window = $(window);
const mobile = 768;

class StickyCta extends EventEmitter {
	constructor($el) {
		super();
		this.$el = $el;
	}

	set $el($el) {
		if (typeof $el === 'string') $el = $($el);
		this._$el = $el;
		this.setInitialPos();
	}

	get $el() {
		return this._$el;
	}

	setInitialPos() {
		this.initialPos = this.$el.length ? this.$el.offset().top : 0;
	}

	reinit($el) {
		this.$el = $el;
		this.setIsSticky();
	}

	isSticky() {
		return this.$el.hasClass('sticky');
	}

	enable() {
		this.$el.removeClass('offscreen').addClass('enabled');
	}

	disable() {
		this.$el.removeClass('enabled');
	}

	setIsSticky() {
		if (!this.$el.length) return;
		if (this._shouldStick()) {
			this.emit('sticky', this.$el);
			this.$el.addClass('sticky');
		} else {
			this.emit('unsticky', this.$el);
			this.$el.removeClass('sticky');
			this.setInitialPos();
		}
	}

	isMobile() {
		return $window.width() <= mobile;
	}

	_shouldStick() {
		if (this.$el.hasClass('offscreen') || !this.isMobile()) return false;
		const scrollPos = $window.scrollTop() + $window.outerHeight();
		const offset = this.initialPos + this.$el.outerHeight();
		return scrollPos < offset;
	}
}

export default ($el) => {
	if (!$el || !$el.length) return;
	const cta = new StickyCta($el);
	const scrollHandler = throttle(cta.setIsSticky.bind(cta), 50);

	$window
		.scroll(scrollHandler).trigger('scroll')
		.resize(debounce(() => cta.setInitialPos(), 100))
		.trigger('scroll');

	return cta;
}
